import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { InlineSVGModule } from 'ng-inline-svg';

import { BaazarvoiceService } from '../../api/services/baazarvoice.service';
import { BvReviewsComponent } from '../../components/bv-reviews';
import { ComponentsModule } from '../../components';
import { SubmitReviewComponent } from './submit-review/';

const routes: Routes = [
  { path: '', component: SubmitReviewComponent }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes),
    CommonModule,
    ComponentsModule,
    // InlineSVGModule.forRoot({ baseUrl: '/resources/global/stay-mgmt/assets/svg/' })
    InlineSVGModule.forRoot({baseUrl: `/resources/global/stay-mgmt/v12.0.0/assets/svg/`}),

  ],
  declarations: [
    SubmitReviewComponent,
    BvReviewsComponent
  ],
  exports: [
    RouterModule,
    SubmitReviewComponent
  ],
  providers: [
    BaazarvoiceService
  ]
})
export class SubmitReviewModule { }



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/routes/submit-review/submit-review.module.ts